module.exports = __webpack_public_path__ + "static/media/filters_active.ace669b8.svg";